import LogoMRG from './LogoMRG';
import { PAGES } from '../data/constants';

export default function Footer({ goTo }) {
  return (
    <footer className="footer">
      <div>
        <LogoMRG dark />
        <div className="footer-copy">© {new Date().getFullYear()} Mantenimiento M&amp;RG · Todos los derechos reservados</div>
        <div className="footer-nit">NIT 901.248.424-3 · mantenimiento@myrg.com.co</div>
      </div>
      <nav className="footer-links" aria-label="Navegación secundaria">
        {PAGES.map((p) => (
          <button key={p} onClick={() => goTo(p)}>
            {p.charAt(0).toUpperCase() + p.slice(1)}
          </button>
        ))}
      </nav>
    </footer>
  );
}
